import * as React from "react";
import styled from "styled-components";

import { Text } from "../../../../components/atoms";
import { LoaderContainer } from "../../../../containers/common/loader";
import { theme } from "../../../../theme";

interface IProps {
  className?: string;
  defaultScrollText?: string;
  highlight?: string;
  innerRef: React.RefObject<HTMLElement>;
  isItemsLoading?: boolean;
  itemKey?: string;
  itemName?: string;
  items: (object | string)[];
  disabledItems?: string[];
  onSelect(props: object | string): void;
  children?: React.ReactNode;
}

const SelectorListItem = styled(Text)`
  margin: 0;
  padding: 10px 15px;
  font-weight: 600;
  text-align: left;
  cursor: pointer;

  &:hover,
  &.highlighted {
    background: ${theme.color.ruubyGreyLight};
  }

  &.disabled {
    background: ${theme.color.ruubyGreyBg};
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const SelectorListWrapper = styled.div`
  position: absolute;
  top: 38px;
  width: 100%;
  max-height: 250px;
  border: 1px solid ${theme.color.borderColor};
  border-top: 0;
  border-radius: 0 0 20px 20px;
  background: white;
  overflow-y: scroll;
  z-index: 899;

  ${SelectorListItem} {
    border-bottom: 1px solid ${theme.color.borderColor};

    &:last-child {
      border-bottom: 0;
    }
  }
`;

const SelectorList: React.FC<IProps> = (props) => {
  const mapList = props.items.map((item, index) => {
    const currentItemName: string =
      props.itemName && typeof item === "object"
        ? (item[props.itemName] as string)
        : (item as string);
    const isDisabledItem = props.disabledItems?.includes(currentItemName);

    return (
      <SelectorListItem
        key={
          props.itemKey && typeof item === "object"
            ? (item[props.itemKey] as string)
            : index
        }
        onClick={isDisabledItem ? undefined : () => props.onSelect(item)}
        className={`
        ${currentItemName === props.highlight ? "highlighted" : ""}
        ${props.defaultScrollText === currentItemName ? "default" : ""}
        ${isDisabledItem ? "disabled" : ""}`}
      >
        {currentItemName}
      </SelectorListItem>
    );
  });

  return (
    <SelectorListWrapper innerRef={props.innerRef} className={props.className ?? "search-time-dropdown"}>
      {props.isItemsLoading ? (
        <LoaderContainer type="block" />
      ) : (
        <React.Fragment>
          {props.children}
          {mapList}
        </React.Fragment>
      )}
    </SelectorListWrapper>
  );
};

export { SelectorList };
